import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form as FormikForm } from 'formik'

const Form = (props) => {
  const { initialValues, handleSubmit, children, validate, render } = props

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validate={validate}
      render={(renderProps) => {
        return (
          <FormikForm>
            {children}
            {render && render(renderProps)}
          </FormikForm>
        )
      }}
    />
  )
}

Form.defaultProps = {
  initialValues: null,
  handleSubmit: null,
  children: null,
  validate: null,
  render: null
}

Form.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.string
  ]),
  initialValues: PropTypes.shape({}),
  handleSubmit: PropTypes.func,
  validate: PropTypes.func,
  render: PropTypes.func
}

export default Form
